"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PregeneratedFieldSet = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
const EBecropService_1 = __importDefault(require("./EBecropService"));
const State_1 = __importDefault(require("./modules/State"));
const Recommendations_1 = require("@becrop/abstract/Models/Recommendations");
const Acreage_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Acreage"));
const Crop_1 = __importDefault(require("@becrop/abstract/Models/Crop"));
const Recommendations_2 = require("@becrop/abstract/Models/Recommendations");
class PregeneratedFieldSet {
    constructor(obj) {
        this.name = obj.name || '#NameSetFields';
        this.fields = obj.fields || new Array();
    }
}
exports.PregeneratedFieldSet = PregeneratedFieldSet;
class EBecropController {
    constructor() {
        // Paginate Fields
        this.fetchedPagedFields = new Array();
        this.isFilterPanelExpanded = false;
        this.isActiveDrawingZone = false;
        this.isCreateDrawingZone = false;
        this.isFieldListExpanded = false;
        this.service = new EBecropService_1.default();
        this.filteredState = new State_1.default();
        this.resolution = 'low'; // low or high
        this.orderFinish = false;
        this.rasterFilterPixel = 'all';
        this.filteredStateComplete = false;
        this.notCenterArea = false;
        this.isLoadingFields = false;
        this.needsFieldTeaser = true;
        this.isFieldTeaserDeployed = false;
        this.fields = new Array();
        this.fieldsPerPageServer = 100;
        this.numPagesInClientPerServerPage = 4;
        this.fieldsPerPageClient = Math.floor(this.fieldsPerPageServer / this.numPagesInClientPerServerPage);
        this.allFieldsByClient = [];
        this.pregeneratedFields = new PregeneratedFieldSet({});
        this.pregeneratedCompatibleFields = new PregeneratedFieldSet({});
        this.currentField = null;
        this.orderPanelExpand = false;
        this.currentPageFields = { page: 0, fields: [] };
    }
    ebecropRasterSetup(url, name) {
        const color = [
            'interpolate',
            ['linear'],
            ['band', 1],
            0,
            [0, 0, 0, 0],
            0.00001,
            '#E52721',
            0.49,
            '#E52721',
            0.49999,
            '#FF9A51',
            0.5,
            '#FF9A51',
            1,
            '#E6D581',
        ];
        return { geotiffConfig: { url: url, nodata: 255, max: 3, min: 0 }, layerConfig: { color: color, name: name, zindex: 1 } };
    }
    generateShortcuts() {
        window.addEventListener('keydown', (event) => {
            if ((event.shiftKey && event.key === 'O') ||
                (event.shiftKey && event.key === 'o')) {
                this.updateFilterPanelExpanded();
            }
            else if ((event.shiftKey && event.key === 'P') ||
                (event.shiftKey && event.key === 'p')) {
                if (this.resolution !== 'low') {
                    this.updateDrawingZone();
                }
            }
            else if ((event.altKey && event.key === 'V') ||
                (event.altKey && event.key === 'v')) {
                if (this.rasterFilterPixel !== 'none') {
                    this.updateRasterFilterPixel('none');
                }
                else {
                    this.updateRasterFilterPixel('all');
                }
            }
            else if ((event.shiftKey && event.key === 'I') ||
                (event.shiftKey && event.key === 'i') ||
                (event.shiftKey && event.key === '0')) {
                this.updateRasterFilterPixel('all');
            }
            else if (event.shiftKey && event.key === '1') {
                this.updateRasterFilterPixel('low');
            }
            else if (event.shiftKey && event.key === '2') {
                this.updateRasterFilterPixel('medium');
            }
            else if (event.shiftKey && event.key === '3') {
                this.updateRasterFilterPixel('hight');
            }
            else if (event.shiftKey &&
                event.key === 'Delete' &&
                this.isCreateDrawingZone) {
                this.updateCreatingZone();
            }
            else if (event.shiftKey && event.key === 'Escape') {
                this.redirectionUtility.redirect('/dashboard');
            }
            else if (event.key === 'Escape') {
                if (this.isActiveDrawingZone) {
                    this.updateDrawingZone();
                }
                else if (this.isFilterPanelExpanded) {
                    thisupdateFilterPanelExpanded();
                }
            }
            else if (event.key === 'Enter') {
                if (this.isActiveDrawingZone) {
                    this.updateDrawingZone();
                }
            }
        });
    }
    setEBecropStyle(value, eBecropLayers) {
        for (const eBecropLayer of eBecropLayers) {
            if (value === 'low') {
                eBecropLayer.setStyle({
                    color: [
                        'interpolate',
                        ['linear'],
                        ['band', 1],
                        0,
                        [0, 0, 0, 0],
                        0.00001,
                        '#E6D58100',
                        0.49,
                        '#E6D58100',
                        0.49999,
                        '#FF9A5100',
                        0.5,
                        '#FF9A5100',
                        0.99,
                        '#FF9A5100',
                        1,
                        '#E6D581',
                    ],
                });
            }
            else if (value === 'medium') {
                eBecropLayer.setStyle({
                    color: [
                        'interpolate',
                        ['linear'],
                        ['band', 1],
                        0,
                        [0, 0, 0, 0],
                        0.00001,
                        '#E6D58100',
                        0.49,
                        '#E6D58100',
                        0.49999,
                        '#FF9A51',
                        0.5,
                        '#FF9A51',
                        0.99,
                        '#FF9A51',
                        1,
                        '#E5272100',
                    ],
                });
            }
            else if (value === 'hight') {
                eBecropLayer.setStyle({
                    color: [
                        'interpolate',
                        ['linear'],
                        ['band', 1],
                        0,
                        [0, 0, 0, 0],
                        0.00001,
                        '#E52721',
                        0.49,
                        '#E52721',
                        0.49999,
                        '#FF9A5100',
                        0.5,
                        '#FF9A5100',
                        0.99,
                        '#FF9A5100',
                        1,
                        '#E5272100',
                    ],
                });
            }
            else if (value === 'all') {
                eBecropLayer.setStyle({
                    color: [
                        'interpolate',
                        ['linear'],
                        ['band', 1],
                        0,
                        [0, 0, 0, 0],
                        0.00001,
                        '#E52721',
                        0.49,
                        '#E52721',
                        0.49999,
                        '#FF9A51',
                        0.5,
                        '#FF9A51',
                        0.99,
                        '#FF9A51',
                        1,
                        '#E6D581',
                    ],
                });
            }
            else if (value === 'none') {
                eBecropLayer.setStyle({
                    color: [
                        'interpolate',
                        ['linear'],
                        ['band', 1],
                        0,
                        [0, 0, 0, 0],
                        0.00001,
                        '#E47C7900',
                        0.49,
                        '#E47C7900',
                        0.5,
                        '#E6D58100',
                        0.99,
                        '#E6D58100',
                        1,
                        '#67BF3E00',
                    ],
                });
            }
        }
    }
    findFieldsClient(filter) {
        return this.allFieldsByClient.filter((field) => {
            return field.name.toLowerCase().includes(filter.toLowerCase());
        });
    }
    setFieldListExpanded() {
        this.isFieldListExpanded = !this.isFieldListExpanded;
    }
    setCurrentField(newCurrentField) {
        this.currentField = newCurrentField;
    }
    updateRasterFilterPixel(newFilter) {
        this.rasterFilterPixel = newFilter;
    }
    updatefilterState(url = '', state = '', cropName = '', metric = '') {
        this.filteredState = {
            url: url,
            state: state,
            crop: { name: cropName, icon: '', color: '' },
            metric: metric,
        };
    }
    updateFilteredZone(newZone) {
        this.filteredZone = newZone;
        const states = this.getData;
        const curentState = states.find((state) => { if (state.state === newZone)
            return state; });
        this.updateResolution('high');
        this.updatefilterState(curentState.url, curentState.state, curentState.crop.name, curentState.metric);
    }
    get isLoadingOrder() {
        return this.service.isLoadingOrder;
    }
    updateOrder(value) {
        this.orderFinish = value;
    }
    expandOrderPanel() {
        this.orderPanelExpand = true;
    }
    disabledOrderPanel() {
        this.orderPanelExpand = false;
    }
    async orderBecrop(region, coordinates, geodata, hectares, email, fieldName, fieldId, recomendationsAccess) {
        await this.service.orderBecrop(region.length > 0 ? region : this.filteredState.state.length > 0 ? this.filteredState.state : 'United States', fieldName, parseInt(fieldId), this.filteredState.metric.length > 0 ? this.filteredState.metric : this.statesMetrics[0], this.filteredState.crop.name.length > 0 ? this.filteredState.crop.name : this.statesCrops[0], coordinates, geodata, hectares, this.isCreateDrawingZone, email, recomendationsAccess);
    }
    getStatesContainingText(text) {
        const filteredStates = this.statesNames.filter((state) => {
            return state.toLowerCase().includes(text.toLowerCase());
        });
        return filteredStates;
    }
    updateResolution(newResolution) {
        this.resolution = newResolution;
    }
    async init(url = '') {
        this.service = new EBecropService_1.default(url);
        await this.service.call();
    }
    get getData() {
        return this.service.data;
    }
    get isLoading() {
        return this.service.isLoading;
    }
    get statesNames() {
        const namesSet = new Set();
        for (const state of this.getData) {
            namesSet.add(state.state);
        }
        return Array.from(namesSet);
    }
    get statesCrops() {
        const cropsSet = new Set();
        for (const state of this.getData) {
            cropsSet.add(state.crop.name);
        }
        return Array.from(cropsSet);
    }
    get statesMetrics() {
        const metricsSet = new Set();
        for (const state of this.getData) {
            metricsSet.add(state.metric);
        }
        return Array.from(metricsSet);
    }
    findState(stateName, cropName, metricName, center = true) {
        this.notCenterArea = false;
        if (!center) {
            this.notCenterArea = true;
        }
        for (const state of this.getData) {
            if (state.state === stateName && state.crop.name === cropName && state.metric === metricName) {
                this.filteredState = state;
                this.filteredStateComplete = true;
                return state;
            }
        }
    }
    updateFilterPanelExpanded() {
        this.isFilterPanelExpanded = !this.isFilterPanelExpanded;
    }
    updateDrawingZone() {
        this.isActiveDrawingZone = !this.isActiveDrawingZone;
    }
    updateCreatingZone() {
        this.isCreateDrawingZone = !this.isCreateDrawingZone;
    }
    /* FieldTeaser Management */
    setProductPermissions(productLevel) {
        this.hasProductPermissions = (productLevel === 2) ? true : false;
    }
    checkFieldTeaserNeed() {
        // Leer del localstorage si necesita o no el teaser
        const needsFieldTeaser = localStorage.getItem('NeedsFieldTeaser');
        if (needsFieldTeaser === null) {
            this.needsFieldTeaser = true;
        }
        else {
            (needsFieldTeaser === 'true') ? this.needsFieldTeaser = true : this.needsFieldTeaser = false;
        }
    }
    deployFieldTeaser() {
        this.isFieldTeaserDeployed = true;
    }
    dismissFieldTeaser(forever) {
        this.isFieldTeaserDeployed = false;
        if (forever)
            this.dontNeedFieldTeaser();
    }
    dontNeedFieldTeaser() {
        localStorage.setItem('NeedsFieldTeaser', 'false');
    }
    /* Fields Management */
    get hasFields() {
        return (this.fields.length > 0) ? true : false;
    }
    parseClientPageIntoServerPage(clientPage) {
        return Math.ceil(clientPage / this.numPagesInClientPerServerPage);
    }
    parseServerPageIntoClientPage(serverPage) {
        if (this.totalFields < this.fieldsPerPageServer) {
            return Math.ceil(this.totalFields / this.fieldsPerPageClient);
        }
        else {
            return Math.ceil(serverPage * this.numPagesInClientPerServerPage);
        }
    }
    get numVisibleClientPages() {
        return this.fetchedPagedFields.length;
    }
    deconstructServerItemsIntoClientChunks(serverArray, clientChunkSize, initialPageNumber) {
        const result = new Array();
        for (let i = 0; i < serverArray.length; i += clientChunkSize) {
            result.push({
                page: initialPageNumber++,
                fields: serverArray.slice(i, i + clientChunkSize)
            });
        }
        return result;
    }
    async getStoredFields(page) {
        // Function to retrieve the already stored fields
        var _a, _b;
        this.isLoadingFields = true;
        const serverPage = this.parseClientPageIntoServerPage(page);
        try {
            const ixAmongFetched = this.fetchedPagedFields.findIndex((pf) => pf.page === page);
            if (ixAmongFetched !== -1) {
                // Is Among Fetched
                this.currentPageFields = this.fetchedPagedFields[ixAmongFetched];
                this.currentPageFields.fields.forEach((field) => this.allFieldsByClient.push(field));
            }
            else {
                // Is not fetched yet
                // /data/results/ebecrop/fields?page=${serverPage}
                // 
                const endpointURL = `/data/ebecrop/all_fields?page=${serverPage}`; //`/data/ebecrop/all_fields?page=${serverPage}`
                const resp = await axios.get(endpointURL);
                /*                 const resp = {
                                    data: this.fake
                                } */
                this.fieldsPerPageServer = resp.data.per_page;
                this.fieldsPerPageClient = Math.floor(this.fieldsPerPageServer / this.numPagesInClientPerServerPage);
                this.totalFields = resp.data.total;
                this.numServerPages = resp.data.last_page;
                this.numClientPages = this.parseServerPageIntoClientPage(this.numServerPages);
                function getRecomms(f) {
                    const recomms = new Array();
                    if (f.recommendations_brief === 'has_recommendations') {
                        f.recommendations.forEach((cat) => {
                            cat.product_groups.forEach((pg) => {
                                const newRec = new Recommendations_1.Recommendation({});
                                newRec.category = new Recommendations_2.MetricCategory({
                                    label: cat.label,
                                    short: cat.category,
                                });
                                newRec.product = new Recommendations_2.AgInput({
                                    hierarchyOrder: pg.hierarchy_order,
                                    hierarchyDepth: pg.hierarchy_level,
                                    name: pg.group_name,
                                    slug: pg.slug,
                                    parentSlug: pg.parent_group_slug,
                                    avgLevel: pg.average_level,
                                });
                                newRec.samples = [{}];
                                newRec.level = pg.average_level;
                                recomms.push(newRec);
                            });
                        });
                    }
                    return recomms;
                }
                let fieldsFetched = [];
                if (resp.data.data.length > 0) {
                    fieldsFetched = resp.data.data.map((f) => new Recommendations_1.FieldRecommendation({
                        areaID: -1,
                        id: f.id,
                        name: f.name,
                        polygon: f.geodata,
                        samples: [],
                        crop: new Crop_1.default({ name: f.crop.crop_name.split(',')[0], icon: f.crop.logo_name, color: f.crop.name }),
                        hasResults: false,
                        acreage: new Acreage_1.default(f.metadata.extension.value, f.metadata.extension.unit),
                        diagnostic: { acreage: f.disclaimer.size, region: f.disclaimer.position, crop: f.disclaimer.crop },
                        recomendationsBrief: f.recommendations_brief,
                        recomendationsAvailability: f.recommendations_availability
                    }, getRecomms(f)));
                }
                const fieldBatches = this.deconstructServerItemsIntoClientChunks(fieldsFetched, this.fieldsPerPageClient, page);
                this.fetchedPagedFields = [...this.fetchedPagedFields, ...fieldBatches];
                this.fetchedPagedFields.sort((a, b) => a.page - b.page);
                this.currentPageFields = this.fetchedPagedFields.find((fpf) => fpf.page === page);
                (_a = this.currentPageFields) === null || _a === void 0 ? void 0 : _a.fields.forEach((field) => this.allFieldsByClient.push(field));
            }
            if (this.currentPageFields || ((_b = this.currentPageFields) === null || _b === void 0 ? void 0 : _b.fields.length) > 0) {
                this.fields = this.currentPageFields.fields;
            }
        }
        catch (e) {
            console.log(e);
        }
        this.isLoadingFields = false;
    }
    async storePregeneratedFields(onlyCompatible) {
        // Function to save the pregenerated fields imported by the user, 
        // if onlyCompatible -> then the ones stored in the pregeneratedCompatibleFields
        // if not -> all in pregeneratedFields
        const endpointURL = 'data/results/ebecrop/recommedations/coordinates';
        let ebecrop_fields;
        if (onlyCompatible) {
            ebecrop_fields = this.pregeneratedCompatibleFields.fields.map((f, i) => {
                return {
                    'geodata': f.polygon,
                    'id': null,
                    'name': `${this.pregeneratedCompatibleFields.name}_${i + 1}`,
                    'with_recommendations': true
                };
            });
        }
        else {
            ebecrop_fields = this.pregeneratedFields.fields.map((f, i) => {
                return {
                    'geodata': f.polygon,
                    'id': null,
                    'name': `${this.pregeneratedCompatibleFields.name}_${i + 1}`,
                    'with_recommendations': false
                };
            });
        }
        try {
            if (ebecrop_fields.length === 0)
                return;
            const resp = await axios.post(endpointURL, ebecrop_fields);
            const newStoredFields = resp.data.ebecrop_fields.map((ef) => new Recommendations_1.FieldRecommendation({
                // Obj for Field
                areaID: -1,
                id: ef.id,
                name: ef.name,
                polygon: ef.geodata
            }, new Array()));
            const previouslyStoredFields = this.fetchedPagedFields.map((pf) => pf.fields).flat();
            const fieldBatches = this.deconstructServerItemsIntoClientChunks([...newStoredFields, ...previouslyStoredFields], this.fieldsPerPageClient, 1);
            this.fetchedPagedFields = new Array();
            this.fetchedPagedFields = [...fieldBatches];
            this.numClientPages = this.fetchedPagedFields.length;
            this.numServerPages = this.parseClientPageIntoServerPage(this.numClientPages);
            this.currentPageFields = this.fetchedPagedFields.find((fpf) => fpf.page === 1);
            this.fields = [...this.currentPageFields.fields];
            /* if(this.fields.length >  0) {
                this.currentField = this.fields[0]
            } */
        }
        catch (e) {
            console.log(e);
        }
    }
    /*     const polygonsImported => {parseGISToPolygons(file) {
            return string[]
        }}
    
            const inputFieldText = 'Blackwater'
        
            const fieldsImported = polygonsImported.map((p:string, i:number) => new FieldRecommendation({
                polygon: p,
                name: `${inputFieldText}_${i}`
            },{}))
    
            const fieldsImportedSet = new PregeneratedFieldSet({name: inputFieldText, fields: fieldsImported})
    
            pregenerateFields(fieldsImportedSet)
        */
    pregenerateFields(pgf) {
        // Function to decode the fields in the GIS Files and create the correspondant pregenerated entities
        // OJO: EN OTRO FICHERO HABRÁ QUE HACER UN METODO QUE RECIBA FICHEROS GIS Y LOS CONVIERTA EN POLIGONOS Y EN UN ARRAY DE FIELDS
        this.pregeneratedFields = pgf;
        this.pregeneratedCompatibleFields = pgf;
        this.filterCompatiblePregeneratedFields();
    }
    filterCompatiblePregeneratedFields() {
        // Function to divide the fields among all and only ones meeting requirements
        this.pregeneratedCompatibleFields.fields = new Array();
        this.pregeneratedCompatibleFields.fields = this.pregeneratedFields.fields.filter((pf) => pf.meetsEBeCropConditions).map((pfc) => pfc);
    }
}
exports.default = EBecropController;
